import { Stack } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

const PdfPage = ({ children }: Props) => {
  return (
    <Stack
      sx={{
        p: 2,
        height: '297mm',
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(/assets/background/logoSG.png)`,
        backgroundSize: '400px',
        backgroundPosition: 'center bottom',
        backgroundRepeat: 'no-repeat',
        borderWidth: 0,
        borderBottomWidth: 1,
        borderStyle: 'dashed',
        borderColor: (theme) => theme.palette.divider,
      }}
    >
      {children}
    </Stack>
  );
};

export { PdfPage };
